import p from "./design-system.es192.js";
/* empty css                    */
import b from "./design-system.es58.js";
import D from "./design-system.es65.js";
import { resolveComponent as g, openBlock as r, createElementBlock as s, normalizeClass as d, createElementVNode as u, createTextVNode as o, createBlock as h, createCommentVNode as m, toDisplayString as I, renderSlot as f } from "vue";
import w from "./design-system.es116.js";
/* empty css                    */
import k from "./design-system.es128.js";
const v = {
  name: "DsDatePicker",
  components: {
    Icon: b,
    InputField: D
  },
  props: {
    /**
     * Determines the current value of the Date Field
     */
    modelValue: [Date, Object, String, Array],
    /**
     * Controls visualization of rendering form validation error states
     */
    submitted: Boolean,
    /**
     * Required field for validation purposes
     */
    required: Boolean,
    /**
     * HTML input element name
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Label to render above the Date field when active
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Controls if date input is modeling a range
     */
    range: Boolean,
    /**
     * Changes formatting to better accommodate birthday date
     */
    birthday: Boolean,
    /**
     * Allows user to manually input date
     */
    allowInput: Boolean,
    /**
     * Add time to the date picker
     */
    time: Boolean,
    /**
     * Time picker only without date calendar
     */
    timeOnly: Boolean,
    /**
     * Step to increment minutes by on the time picker
     */
    minuteIncrement: {
      type: Number,
      default: 5
    },
    /**
     * Date picker only no time
     */
    dateOnly: Boolean,
    /**
     * Custom string to toggle date picker, must be inline-block
     */
    customReference: Boolean,
    /**
     * Use fixed position for datepicker input
     */
    static: Boolean,
    /**
     * Disable all dates before specifice, use "today" as shortcut
     */
    disableBeforeDate: {
      type: [Date, String, Object],
      default: null
    },
    /**
     * Prevent user from updating the input
     */
    readonly: Boolean,
    /**
     * Force the error state to show if parent is controlling it
     */
    forceInvalid: Boolean
  },
  emits: [
    "close",
    "update:modelValue"
  ],
  setup() {
    return {
      i18n: w()
    };
  },
  data() {
    return {
      fp: null,
      active: !1
    };
  },
  computed: {
    showError() {
      return this.forceInvalid || this.required && this.submitted && !this.modelValue;
    },
    placeholder() {
      return this.birthday && this.allowInput ? this.i18n.messages["date.format"] : "";
    },
    showDefaultInput() {
      return this.static || !this.customReference;
    },
    formattedDate() {
      return this.fp ? this.fp.formatDate(this.fp.config.defaultDate, this.fp.config.altFormat) : "";
    }
  },
  watch: {
    modelValue: {
      handler(t) {
        let e = t;
        const i = this.getValue(this.fp.selectedDates);
        if (this.timeOnly || this.range || this.dateOnly) {
          if (e === i)
            return;
        } else if (typeof e == "string" && (e = new Date(e)), e && i && e.getTime() === i.getTime())
          return;
        let n = e;
        this.timeOnly && (n = this.fromEncodedTimeString(n)), this.fp && this.fp.setDate(n, !0);
      },
      deep: !0
    },
    disableBeforeDate(t) {
      this.fp && this.fp.set("minDate", t);
    },
    range(t) {
      this.fp && this.fp.set("mode", t ? "range" : "single");
    }
  },
  mounted() {
    this.setupFlatpickr();
  },
  beforeUnmount() {
    this.destroyFlatpickr();
  },
  methods: {
    setupFlatpickr() {
      if (this.fp)
        return;
      let t = "F j, Y";
      this.time && (t = "F j, Y h:iK"), this.birthday && (t = "m/d/Y"), this.timeOnly && (t = "h:iK");
      let e = this.modelValue;
      this.timeOnly && (e = this.fromEncodedTimeString(this.modelValue));
      const i = {
        onOpen: this.onOpen,
        onClose: this.onClose,
        onChange: this.onChange,
        altInput: !0,
        altFormat: t,
        allowInput: this.allowInput,
        defaultDate: e,
        static: this.customReference || this.static,
        mode: this.range ? "range" : "single",
        minDate: this.disableBeforeDate,
        enableTime: this.time || this.timeOnly,
        noCalendar: this.timeOnly,
        wrap: !0,
        disableMobile: !0,
        minuteIncrement: this.minuteIncrement
      };
      this.static ? this.fp = new p(this.$refs.dateInput, i) : this.fp = new p(this.$el, i);
      const n = this.$refs.dateInput;
      if (n) {
        const a = n.querySelector(".flatpickr-input");
        a.removeAttribute("type"), a.setAttribute("style", "display:none"), this.required && a.setAttribute("required", !0);
      }
    },
    destroyFlatpickr() {
      this.fp && this.fp.destroy(), this.fp = null;
    },
    onChange(t) {
      this.$emit("update:modelValue", this.getValue(t));
    },
    onOpen() {
      this.fp.now.getDate() !== (/* @__PURE__ */ new Date()).getDate() && (this.fp.now = /* @__PURE__ */ new Date(), this.fp.redraw()), this.active = !0;
    },
    onClose(t) {
      const e = this.getValue(t);
      this.modelValue !== e && this.$emit("update:modelValue", e), this.$emit("close"), this.active = !1;
    },
    getValue(t) {
      if (this.range)
        return t;
      if (Array.isArray(t) && t.length) {
        const e = t[0];
        return this.timeOnly ? this.toEncodedTimeString(e) : this.dateOnly && e ? new Date(e.getTime() - e.getTimezoneOffset() * 6e4).toISOString().split("T")[0] : e;
      }
      return null;
    },
    toEncodedTimeString(t) {
      if (!t)
        return null;
      let e = t.getHours().toString();
      e = e.length === 1 ? `0${e}` : e;
      let i = t.getMinutes().toString();
      return i = i.length === 1 ? `0${i}` : i, e + i;
    },
    fromEncodedTimeString(t) {
      if (!t || typeof t != "string")
        return null;
      const e = t.substr(0, 2), i = t.substr(2, 4), n = /* @__PURE__ */ new Date();
      return n.setHours(e), n.setMinutes(i), n;
    }
  }
}, O = {
  key: 0,
  class: "readonly"
}, B = ["id"], V = ["for"], S = {
  ref: "dateInput",
  class: "date-input"
}, _ = ["id", "placeholder"], C = {
  key: 1,
  class: "assistive-text"
}, F = {
  key: 2,
  class: "error-text"
}, T = {
  key: 2,
  class: "custom-reference",
  "data-toggle": ""
}, E = ["id"];
function q(t, e, i, n, a, l) {
  const y = g("InputField"), c = g("Icon");
  return r(), s("div", {
    class: d(["date-picker", { "has-selected": i.modelValue, active: a.active }, { "has-custom-reference": i.customReference }])
  }, [
    i.readonly ? (r(), s("div", O, [
      u("input", {
        id: i.name,
        type: "text",
        "data-input": ""
      }, null, 8, B),
      e[0] || (e[0] = o()),
      i.readonly ? (r(), h(y, {
        key: 0,
        name: i.name,
        label: i.label,
        required: i.required,
        "model-value": l.formattedDate,
        readonly: ""
      }, null, 8, ["name", "label", "required", "model-value"])) : m("", !0)
    ])) : l.showDefaultInput ? (r(), s("div", {
      key: 1,
      class: d(["date-picker-container", { "no-label": !i.label, error: l.showError }])
    }, [
      i.label ? (r(), s("label", {
        key: 0,
        for: i.name,
        class: d({ required: i.required })
      }, I(i.label), 11, V)) : m("", !0),
      e[2] || (e[2] = o()),
      u("div", S, [
        u("input", {
          id: i.name,
          type: "text",
          "data-input": "",
          placeholder: l.placeholder
        }, null, 8, _),
        e[1] || (e[1] = o()),
        u("div", {
          class: d(["input-icon", { error: l.showError }]),
          "data-toggle": ""
        }, [
          i.timeOnly ? (r(), h(c, {
            key: 0,
            name: "clock"
          })) : (r(), h(c, {
            key: 1,
            name: "calendar"
          }))
        ], 2)
      ], 512),
      e[3] || (e[3] = o()),
      t.$slots.help ? (r(), s("div", C, [
        f(t.$slots, "help")
      ])) : m("", !0),
      e[4] || (e[4] = o()),
      t.$slots.error && l.showError ? (r(), s("div", F, [
        f(t.$slots, "error")
      ])) : m("", !0)
    ], 2)) : (r(), s("div", T, [
      u("input", {
        id: i.name,
        type: "text",
        "data-input": ""
      }, null, 8, E),
      e[5] || (e[5] = o()),
      f(t.$slots, "default")
    ]))
  ], 2);
}
const H = /* @__PURE__ */ k(v, [["render", q]]);
export {
  H as default
};
//# sourceMappingURL=design-system.es50.js.map
